<div class="search-input-wrapper" #searchWrapper>
  <input type="text"
    [(ngModel)]="searchText"
    name="searchText"
    id="searchText"
    placeholder="Search..."
    (input)="onSearch(searchText)"
    class="search-input"
    (keyup.enter)="fetchResults(1)"
    autocomplete="off"
    >
  
  <div *ngIf="showNoMatchTooltip" class="suggestions-dropdown no-match-tooltip">
    <fa-icon [icon]="['fas', 'circle-info']"></fa-icon>
    <span>Press Enter to search</span>
  </div>
  
  <div *ngIf="suggestions && suggestions.length && searchText" class="suggestions-dropdown">
    <div *ngFor="let suggestion of suggestions"
         (click)="onSuggestionClick(suggestion)"
         class="suggestion-item">
      <fa-icon [icon]="['fas', 'magnifying-glass']" class="suggestion-icon"></fa-icon>
      <div class="suggestion-text">
        <span class="suggestion-main">{{ formatSuggestionContext(splitSuggestion(suggestion).main) }}</span>
        <span *ngIf="splitSuggestion(suggestion).context" class="suggestion-context">
          {{ splitSuggestion(suggestion).context }}
        </span>
      </div>
    </div>
    <div *ngIf="suggestions.length === 0" class="no-suggestions">No results found</div>
  </div>
</div>
